module.exports = __webpack_public_path__ + "static/media/herobkg.e04ed930.webp";